export default {"src":"/_next/static/media/circleExclamationMarkUiOrangeWithLightBg_24.86138862.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};